import { render, staticRenderFns } from "./TinyEditor.vue?vue&type=template&id=3cdc0f2a&scoped=true&"
import script from "./TinyEditor.vue?vue&type=script&lang=js&"
export * from "./TinyEditor.vue?vue&type=script&lang=js&"
import style0 from "./TinyEditor.vue?vue&type=style&index=0&id=3cdc0f2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc0f2a",
  null
  
)

export default component.exports